import React from "react";

export default function Footer() {
  return (
    <>
      <style>{`
        .footer {
          width: 100%;
          background: #111;
          color: #ddd;
          padding: 25px 15px;
          font-size: 14px;
          border-top: 2px solid #ffcc00;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          flex-wrap: wrap;
        }

        .footer-column {
          flex: 1;
          min-width: 280px;
          text-align: center;
          margin: 0 10px 20px 10px;
        }

        .branch-label {
          font-size: 18px;
          font-weight: 600;
          color: #ffcc00;
          margin-bottom: 10px;
        }

        .footer-title {
          font-size: 20px;
          font-weight: 700;
          background: linear-gradient(to right, #ffe47a, #ffce00, #ffae00);
          -webkit-background-clip: text;
          color: transparent;
          margin-bottom: 6px;
        }

        .footer-address {
          line-height: 1.5;
          font-size: 13px;
          opacity: 0.85;
        }

        .footer-links {
          margin: 8px 0;
        }

        .footer-links a {
          color: #ffcc00;
          margin: 0 8px;
          font-size: 14px;
          text-decoration: none;
          transition: 0.3s;
        }

        .footer-links a:hover {
          color: #fff;
        }

        .footer-bottom {
          margin-top: 8px;
          opacity: 0.6;
          font-size: 12px;
        }

        .footer-page-links {
          width: 100%;
          background: #111;
          text-align: center;
          padding: 12px 0 16px;
          border-top: 1px solid #333;
        }

        .footer-page-links a {
          color: #ffcc00;
          margin: 0 10px;
          font-size: 14px;
          text-decoration: none;
          transition: color 0.2s ease;
        }

        .footer-page-links a:hover {
          color: #fff;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .footer {
            flex-direction: column;
            align-items: center;
            padding: 20px 10px;
          }

          .footer-column {
            min-width: auto;
            width: 100%;
            margin: 0 0 25px 0;
            text-align: center;
          }

          .footer-title {
            font-size: 18px;
          }

          .branch-label {
            font-size: 16px;
          }

          .footer-address {
            font-size: 12px;
          }

          .footer-links a {
            font-size: 13px;
            margin: 0 5px;
          }

          .footer-bottom {
            font-size: 11px;
          }
        }

        @media (max-width: 480px) {
          .footer {
            padding: 15px 5px;
          }

          .footer-column {
            margin: 0 0 20px 0;
          }

          .footer-title {
            font-size: 16px;
          }

          .branch-label {
            font-size: 14px;
          }

          .footer-address {
            font-size: 11px;
          }

          .footer-links {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
          }

          .footer-links a {
            font-size: 12px;
            margin: 2px 4px;
          }

          .footer-bottom {
            font-size: 10px;
          }
        }
      `}</style>

      <footer className="footer" id="footer">
        <div className="footer-column">
          <h4 className="branch-label">Head Branch</h4>
          <h3 className="footer-title">Lakshya Computer Institute <br />
            & Digital Library</h3>

          <p className="footer-address">
          Gobrahiya mod Senuapar, Near Shakti HP Petrol Pump, <br />
          , District Gorakhpur, UP – 273411 <br />
          ISO 9001:2015 Certified  <br />
          Phone: +91 9236895251 | +91 9793059441 | +91 9793307525 <br />
          Email: rrrdigitalworld114@gmail.com | 
        </p>

          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/Courses">Courses</a>
            <a href="/Scholarship">Scholarship</a>
            <a href="/About">About</a>
            <a href="?Contact">Contact</a>
          </div>

          <p className="footer-bottom">
            © 2025 Lakshya Computer Institute. All Rights Reserved.
          </p>
        </div>

        <div className="footer-column">
          <h4 className="branch-label">Branch 2</h4>
          <h3 className="footer-title">Lakshya Computer Institute <br />
            & Digital Library</h3>

          <p className="footer-address">
            Karwal Manjhgawa, Narre road near by RPD Academy <br />
             Tikari, District Gorakhpur, UP – 273411 <br />
            ISO 9001:2015 Certified<br />
            Phone: +91 9236895251 | +91 9793059441 | +91 9793307525 <br />
          Email: rrrdigitalworld114@gmail.com | 
          </p>

          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/Courses">Courses</a>
            <a href="/Scholarship">Scholarship</a>
            <a href="/About">About</a>
            <a href="?Contact">Contact</a>
          </div>

          <p className="footer-bottom">
            © 2025 Lakshya Computer Institute. All Rights Reserved.
          </p>
        </div>

        <div className="footer-column">
          <h4 className="branch-label">Branch 3</h4>
          <h3 className="footer-title">Lakshya Computer Institute <br />
            & Digital Library</h3>

          <p className="footer-address">
            Sonaicha Chouraha,  Gagaha <br />
             District Gorakhpur, UP – 273411 <br />
            ISO 9001:2015 Certified<br />
            Phone: +91 9236895251 | +91 9793059441 | +91 9793307525 <br />
          Email: rrrdigitalworld114@gmail.com | 
          </p>

          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/Courses">Courses</a>
            <a href="/Scholarship">Scholarship</a>
            <a href="/About">About</a>
            <a href="?Contact">Contact</a>
          </div>

          <p className="footer-bottom">
            © 2025 Lakshya Computer Institute. All Rights Reserved.
          </p>
        </div>
      </footer>
      <div className="footer-page-links">
        <a href="/refund">Refund</a>
        <a href="/terms">Terms & Conditions</a>
        <a href="/policy">Policy</a>
        <p style={{ color: '#ddd', marginTop: '8px', fontSize: '13px' }}>
          
        </p>
      </div>
    </>
  );
}
